import { z } from 'zod';

// ID-008 remediation: server-side length bounds
const EMAIL_MAX = 255; // RFC 5321 + margin
const NAME_MAX = 100;

export const LaboratoryAccessDetailsSchema = z.object({
  Status: z.enum(['Active', 'Inactive']),
  LabManager: z.boolean().optional(),
  LabTechnician: z.boolean().optional(),
});

export const LaboratoryAccessSchema = z.record(z.string(), LaboratoryAccessDetailsSchema);

export const OrganizationAccessDetailsSchema = z.object({
  Status: z.enum(['Active', 'Inactive', 'Invited']),
  OrganizationAdmin: z.boolean().optional(),
  LaboratoryAccess: LaboratoryAccessSchema.optional(),
});

export const OrganizationAccessSchema = z.record(z.string(), OrganizationAccessDetailsSchema);

export const UserSchema = z
  .object({
    UserId: z.string().uuid(),
    Email: z.string().min(1).max(EMAIL_MAX),
    PreferredName: z.string().max(NAME_MAX).optional(),
    FirstName: z.string().max(NAME_MAX).optional(),
    LastName: z.string().max(NAME_MAX).optional(),
    Status: z.enum(['Active', 'Inactive', 'Invited']),
    DefaultOrganization: z.string().optional(),
    DefaultLaboratory: z.string().optional(),
    OrganizationAccess: OrganizationAccessSchema.optional(),
    CreatedAt: z.string().optional(),
    CreatedBy: z.string().optional(),
    ModifiedAt: z.string().optional(),
    ModifiedBy: z.string().optional(),
  })
  .strict();

export const CreateUserSchema = z
  .object({
    Email: z.string().min(1).max(EMAIL_MAX),
    PreferredName: z.string().max(NAME_MAX).optional(),
    FirstName: z.string().max(NAME_MAX).optional(),
    LastName: z.string().max(NAME_MAX).optional(),
    DefaultOrganization: z.string().optional(),
  })
  .strict();
export type CreateUser = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = z
  .object({
    PreferredName: z.string().max(NAME_MAX).optional(),
    FirstName: z.string().max(NAME_MAX).optional(),
    LastName: z.string().max(NAME_MAX).optional(),
  })
  .strict();
export type UpdateUser = z.infer<typeof UpdateUserSchema>;

export const UpdateUserDefaultOrganizationSchema = z
  .object({
    DefaultOrganization: z.string().optional(),
  })
  .strict();
export type UpdateUserDefaultOrganization = z.infer<typeof UpdateUserDefaultOrganizationSchema>;

export const UpdateUserLastAccessedInfoSchema = z
  .object({
    OrganizationId: z.string().optional(),
    LaboratoryId: z.string().optional(),
  })
  .strict();
export type UpdateUserLastAccessedInfo = z.infer<typeof UpdateUserLastAccessedInfoSchema>;
